module.exports = __webpack_public_path__ + "static/media/chatbot.5e450173.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_page_solutions/chifco_ia/chatbot.svg
// module id = 655
// module chunks = 0